// extracted by mini-css-extract-plugin
export var closeButton = "_iz-1";
export var closeX = "_iz-3";
export var container = "_iz-0";
export var image = "_iz-2";